import { CircleDot, CheckCircle2, XCircle, MinusCircle, BadgeCheck } from "lucide-react";

const META = {
  ongoing:          { label: "Ongoing",                icon: CircleDot,     cls: "bg-orange-50 text-orange-700 border-orange-200" },
  reviewed:         { label: "Reviewed",               icon: CheckCircle2,  cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  not_reviewed:     { label: "Not Reviewed",           icon: XCircle,       cls: "bg-red-50 text-red-700 border-red-200" },
  not_asked:        { label: "Did not ask for review", icon: MinusCircle,   cls: "bg-sky-50 text-sky-700 border-sky-200" },
  already_reviewed: { label: "Already Reviewed",       icon: BadgeCheck,    cls: "bg-violet-50 text-violet-700 border-violet-200" },
};

export default function ReviewTag({ state, testid }) {
  if (!state || !META[state]) return null;
  const { label, icon: Icon, cls } = META[state];
  return (
    <span
      data-testid={testid || `review-tag-${state}`}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium ${cls}`}
    >
      <Icon size={11} /> {label}
    </span>
  );
}
